import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "en", // Default language
    fallbackLng: "en", // Fallback language
    debug: true, // Enable logging for debugging
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    resources: {
      en: {
        translation: {
          "1. I feel down hearted and blue.":
            "1. I feel down hearted and blue.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "2. Morning is when i feel the best.":
            "2. Morning is when i feel the best.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "3. I have crying spells often.": "3. I have crying spells often.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "4. I have trouble sleeping at night.":
            "4. I have trouble sleeping at night.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "5. I eat as much as I used to.": "5. I eat as much as I used to.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "6. I still enjoy sex.": "6. I still enjoy sex.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "7. I noticed that I am loosing weight.":
            "7. I noticed that I am loosing weight.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "8. I have trouble with constipation.":
            "8. I have trouble with constipation.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "9. My heart beats faster than usual.":
            "9. My heart beats faster than usual.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "10. I get tired for no reason.": "10. I get tired for no reason.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely.",
          "11. My mind is as clear as it used to be.":
            "11. My mind is as clear as it used to be.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "12. I find it easy to do the things I used to do.":
            "12. I find it easy to do the things I used to do.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "13. I am restless and can't keep still.":
            "13. I am restless and can't keep still.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "14. I feel hopeful about the future.":
            "14. I feel hopeful about the future.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "15. I am more irritable than usual.":
            "15. I am more irritable than usual.",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "16. I find it easy to make decisions.":
            "16. I find it easy to make decisions",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "17. I feel that I am useful and needed.":
            "17. I feel that I am useful and needed",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "18. My life is pretty full.": "18. My life is pretty full",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "19. I feel that others would be better off if I were dead.":
            "19. I feel that others would be better off if I were dead",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
          "20. I still enjoy the things I used to.":
            "20. I still enjoy the things I used to",
          "a) None or Little of the time.": "a) Not at all",
          "b) Some of the time": "b) A little",
          "c) Good part of the time.": "c) Moderately",
          "d) Most or all the time.": "d) A lot",
          "Correct Answer": "e) Extremely",
        },
      },
      hi: {
        translation: {
          "1. I feel down hearted and blue.":
            "1. मैं निराश और नीला महसूस कर रहा हूं।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "2. Morning is when i feel the best.":
            "2. सुबह वह समय है जब मैं सबसे अच्छा महसूस करता हूं।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "3. I have crying spells often.": "3. मुझे अक्सर रोना आता है।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "4. I have trouble sleeping at night.":
            "4. मुझे रात को सोने में परेशानी होती है।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "5. I eat as much as I used to.":
            "5. मैं उतना ही खाता हूं जितना पहले खाता था।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "6. I still enjoy sex.": "6. मैं अब भी सेक्स का आनंद लेता हूं।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "7. I noticed that I am losing weight.":
            "7. मैंने देखा कि मेरा वजन कम हो रहा है।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "8. I have trouble with constipation.": "8. मुझे कब्ज की समस्या है।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "9. My heart beats faster than usual.":
            "9. मेरा दिल सामान्य से अधिक तेज़ धड़कता है।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "10. I get tired for no reason.":
            "10. मैं बिना किसी कारण के थक जाता हूँ।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "11. My mind is as clear as it used to be.":
            "11. मेरा मन उतना ही स्पष्ट है जितना पहले हुआ करता था।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "12. I find it easy to do the things I used to do.":
            "12. मुझे वह काम करना आसान लगता है जो मैं करता था।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "13. I am restless and can't keep still.":
            "13. मैं बेचैन हूं और स्थिर नहीं रह सकता।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "14. I feel hopeful about the future.":
            "14. मैं भविष्य को लेकर आशान्वित महसूस करता हूं।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "15. I am more irritable than usual.":
            "15. मैं सामान्य से अधिक चिड़चिड़ा हो गया हूँ।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "16. I find it easy to make decisions.":
            "16. मुझे निर्णय लेना आसान लगता है।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "17. I feel that I am useful and needed.":
            "17. मुझे लगता है कि मैं उपयोगी और आवश्यक हूं।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "18. My life is pretty full.": "18. मेरा जीवन काफी पूर्ण है।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "19. I feel that others would be better off if I were dead.":
            "19.मुझे लगता है कि अगर मैं मर जाता तो दूसरों का भला होता।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
          "20. I still enjoy the things I used to.":
            "20. मैं अब भी उन चीज़ों का आनंद लेता हूँ जिनका मैं पहले आनंद लेता था।",
          "a) None or Little of the time.": "a) बिल्कुल नहीं",
          "b) Some of the time": "b) थोड़ी देर",
          "c) Good part of the time.": "c) मामूली रूप से",
          "d) Most or all the time.": "d) बहुत ज्यादा",
          "Correct Answer": "e) अत्यधिक",
        },
      },
    },
  });

export default i18n;
